import { queryOptions } from "@tanstack/react-query";

const API_URL = import.meta.env.VITE_API_URL;

export interface User {
	userId: string;
	email: string;
	name: string;
	picture: string;
	roles: string[];
}

export const getUserOptions = () => {
	return queryOptions({
		queryKey: ["auth"],
		queryFn: async () => {
			const resp = await fetch(`${API_URL}/auth/user`, {
				method: "GET",
				credentials: "include",
			});
			if (!resp.ok) {
				return null;
			}
			const user = await resp.json();
			return user?.data as User;
		},
		retry: false,
	});
};
